import { isEmpty } from "lodash";
import React, { useState, useRef, useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/actions/action";
import { setAsImage } from "src/store/reducers/asReduce";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import VideoBox from "./VideoBox";
import IconButton from "./IconButton";
import imageCompression from "browser-image-compression";
import { useDispatch } from "react-redux";
import { setDeleteImg, setSaveImg, setUrlImg } from "src/store/reducers/fileReduce";
import { configureStore } from "@reduxjs/toolkit";
import { encode as base64_encode } from "base-64";

const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;
interface IInputFileProps {
  className?: string;
  tagId?: string;
  multipleFlag?: boolean;
  registeredOneTime?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

// 이처럼 function 위에서 글로벌로 선언하여 이 값을 바로 render에 적용해도 된다!!!
// 하지만 global 변수를 최대한 쓰지 않고자 한다.
// const globalId: any = [];

const ImgInputFile = (props: IInputFileProps) => {
  const propsMultipleFlag = props.multipleFlag ? props.multipleFlag : false;

  const dispatch = useDispatch();

  // reduce 영역
  const fileImageUrl = useAppSelector((state) => state.fileReduce.imgUrlFiles);

  const reduceApiData = useAppSelector((state) => state.fileReduce.apiData);

  // 초기 값 세팅 영역
  const [stateTagId, setStateTagId]: any = useState({
    tagIdArray: [],
  });

  // hook 영역
  useEffect(() => {
    // 부모영역 page에서 5번을 호출하기때문에 props 특정값을 비교하여 한번만 실행 하기위한 if문
    if (!isEmpty(props.registeredOneTime)) {
      if (!isEmpty(reduceApiData)) {
        for (let i = 0; i < reduceApiData.length; i++) {
          const jsonFormat = {
            key: reduceApiData[i]["brand"],
            list: imageServerIp + reduceApiData[i]["img_url"],
          };
          dispatch(setUrlImg(jsonFormat));
        }
      }
    }
  }, [reduceApiData]);

  // click event 영역
  const saveFileImage = async (e: any, tagId?: string) => {
    if (!propsMultipleFlag) {
      for (let i = 0; i < fileImageUrl.length; i++) {
        if (tagId === fileImageUrl[i]["key"]) {
          return;
        }
      }
    }
    const scopeFileImage: Array<any> = [];
    const scopeFileImageUrl: Array<any> = [];

    const option = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      initialQuality: 0.7,
    };

    setStateTagId((state: { tagIdArray: any[] }) => ({
      tagIdArray: state.tagIdArray.concat(tagId),
    }));
    for (let i = 0; i < e.target.files.length; i++) {
      const file = e.target.files[i];
      const compressedFile = await imageCompression(file, option);
      const newFile = new File([compressedFile], compressedFile.name);
      scopeFileImage.push(newFile);
      scopeFileImageUrl.push(URL.createObjectURL(compressedFile));
    }
    const jsonSaveFile = {
      key: tagId,
      list: scopeFileImage,
    };

    const jsonUrlFile = {
      key: tagId,
      list: scopeFileImageUrl,
    };
    dispatch(setSaveImg(jsonSaveFile));
    dispatch(setUrlImg(jsonUrlFile));
  };

  const deleteImage = (index: number) => {
    //
    dispatch(setDeleteImg(index));
    const deleteTagArr = stateTagId.tagIdArray.filter((_el: any, idx: number) => idx !== index);
    setStateTagId({
      tagIdArray: [...deleteTagArr],
    });
  };

  return (
    <InputFileSet>
      <label htmlFor={props.tagId}>파일업로드</label>
      <input id={props.tagId} type="file" accept="image/*" name="profile_img" multiple={propsMultipleFlag} onChange={(e) => saveFileImage(e, props.tagId)} />
      {fileImageUrl.length > 0 && (
        <PreviewImg>
          {fileImageUrl.map((v: any, i: number) => {
            if (props.tagId === String(v["key"])) {
              return (
                <li key={i}>
                  <div>
                    <img alt="sample" src={v["list"]} />
                  </div>
                  <IconButton btnName="미리보기 삭제하기" onClick={() => deleteImage(i)}>
                    <SVG name="thumbDel" width={24} height={24} viewBox="0 0 24 24" />
                  </IconButton>
                </li>
              );
            }
          })}
        </PreviewImg>
      )}
    </InputFileSet>
  );
};

const InputFileSet = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-start")}
  > label {
    position: relative;
    flex-basis: 72px;
    display: inline-block;
    width: 72px;
    height: 72px;
    margin: 3px 3px 0 0;
    border: 1px dashed ${({ theme }) => theme.color.lineSecondary};
    border-radius: 4px;
    font-size: 0;
    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      content: "";
      display: block;
      width: 1px;
      height: 11px;
      margin-top: -5px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      content: "";
      display: block;
      width: 11px;
      height: 1px;
      margin-left: -5px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
  }
  > input[type="file"] {
    ${/* 파일 필드 숨기기 */ ""}
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;

const PreviewImg = styled.ul`
  overflow: hidden;
  overflow-x: scroll;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-start")}
  flex: 1;
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > li {
    position: relative;
    padding: 3px 3px 0 0;
    > div {
      overflow: hidden;
      position: relative;
      width: 72px;
      height: 72px;
      border: 1px solid #ddd;
      border-radius: 4px;
      > img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: block;
        object-fit: cover;
        max-width: 100%;
        height: auto;
        box-sizing: border-box;
      }
    }
    > button {
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
      height: 24px;
    }
  }
`;

export default ImgInputFile;
function e(i: number, e: any): React.MouseEventHandler<HTMLButtonElement> | undefined {
  throw new Error("Function not implemented.");
}
